if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
          sellingPlanInput: '[name="selling_plan"]',
        };

        this.handleSellingPlanUpdate = this.handleSellingPlanUpdate.bind(this);
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }
      get variantInput() {
        return this.querySelector(this.selectors.variantIdSelect);
      }
      get sellingPlanInput() {
        return this.querySelector(this.selectors.sellingPlanInput);
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.variantInput.value;

        this.variantData = this.getVariantData();
        this.setCurrentVariant(this.selectedVariantId);

        document.addEventListener('skio::update-selling-plan', this.handleSellingPlanUpdate);
        this.init();
        this.syncWithSkioPlanPicker();
        setTimeout(() => this.syncWithSkioPlanPicker(), 0);

        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          const selectedVariantId = this.variantInput.value;
          this.setCurrentVariant(selectedVariantId);
          this.updateSellingPlanInput();
          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');

          if (this.mainVariantSelects && this.currentVariant) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields && this.productFormActions) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('skio::update-selling-plan', this.handleSellingPlanUpdate);
        this.variantChangeUnsubscriber?.();
        this.observer?.disconnect();
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        if (!this.currentVariant) return;

        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (quantity && newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      getVariantById(variantId) {
        return this.variantData.find((variant) => String(variant.id) === String(variantId));
      }

      setCurrentVariant(variantOrId) {
        const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
        const localVariant = this.getVariantById(variantId);
        const eventVariant = typeof variantOrId === 'object' ? variantOrId : null;
        this.currentVariant =
          localVariant && eventVariant ? { ...localVariant, ...eventVariant } : localVariant || eventVariant || null;
        this.selectedVariantId = this.currentVariant ? String(this.currentVariant.id) : '';
        return this.currentVariant;
      }

      normalizeId(id) {
        return id == null ? '' : String(id).split('/').pop();
      }

      getSelectedSellingPlanAllocation() {
        if (!this.currentVariant || !this.currentSellingPlan) return null;

        const sellingPlanId = this.normalizeId(this.currentSellingPlan.id);
        return this.currentVariant.selling_plan_allocations?.find((allocation) => {
          const allocationSellingPlanId = allocation.selling_plan_id || allocation.selling_plan?.id;
          return this.normalizeId(allocationSellingPlanId) === sellingPlanId;
        });
      }

      updateSellingPlanInput() {
        if (!this.sellingPlanInput) return;

        const allocation = this.getSelectedSellingPlanAllocation();
        this.sellingPlanInput.value = allocation ? this.currentSellingPlan.id : '';
        this.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      handleSellingPlanUpdate(event) {
        const { variant, sellingPlan } = event.detail || {};
        if (!variant || !this.getVariantById(variant.id)) return;

        this.setCurrentVariant(variant);
        this.currentSellingPlan = sellingPlan || null;

        if (this.variantInput && this.currentVariant) {
          this.variantInput.value = this.currentVariant.id;
        }

        this.updateSellingPlanInput();
        this.updatePrice();
      }

      syncWithSkioPlanPicker() {
        const planPickers = Array.from(document.querySelectorAll('skio-plan-picker'));
        const planPicker = planPickers.find((picker) => {
          return picker.selectedVariant?.id && this.getVariantById(picker.selectedVariant.id);
        });

        if (!planPicker) return;

        this.setCurrentVariant(planPicker.selectedVariant);
        this.currentSellingPlan = planPicker.selectedSellingPlan || null;
        this.updateSellingPlanInput();
        this.updatePrice();
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const {
          priceWrapper,
          salePrice,
          unitPriceWrapper,
          compareAtPrice: compareAtPriceElements,
        } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        if (!priceWrapper) return;

        const unitPrice = unitPriceWrapper?.querySelector('.f-price__unit');

        const sellingPlanAllocation = this.getSelectedSellingPlanAllocation();
        const price = sellingPlanAllocation?.price ?? this.currentVariant.price;
        const compareAtPrice =
          sellingPlanAllocation?.compare_at_price ?? this.currentVariant.compare_at_price ?? price;
        const unitPriceValue = sellingPlanAllocation?.unit_price ?? this.currentVariant.unit_price;
        const { unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compareAtPrice && compareAtPrice > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPriceElements && compareAtPriceElements.length && compareAtPrice > price) {
          compareAtPriceElements.forEach((item) => {
            const formattedCompareAtPrice = FoxTheme.Currency.formatMoney(compareAtPrice, moneyFormat);
            item.innerHTML = item.closest('.f-price__sale')
              ? `<s>${formattedCompareAtPrice}</s>`
              : formattedCompareAtPrice;
          });
        } else {
          compareAtPriceElements.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat))
          );
        }

        if (unit_price_measurement && unitPrice && unitPriceValue != null) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            unitPriceValue,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else if (unitPriceWrapper) {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          if (!this.mainProductInfo) return;

          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;

          this.setCurrentVariant(variant);
          if (this.variantInput && this.currentVariant) {
            this.variantInput.value = this.currentVariant.id;
          }
          this.updateSellingPlanInput();
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}
